import 'react-app-polyfill/ie9';
import React from 'react';
import * as ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { initGA } from './utils/tracking';
import { installCustomerAuthRefresh } from './utils/authSession';
import AppErrorFallback from './common/AppErrorFallback';

import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';

import { REACT_APP_ENVIRONMENT } from '@partsbadger/utils';

if (REACT_APP_ENVIRONMENT === 'production') {
    initGA('GTM-58KHNJZ');

    Sentry.init({
        dsn: 'https://96327df4cb1d43cc8e5fafbae725ebf8@o307418.ingest.sentry.io/5398707',
        environment: REACT_APP_ENVIRONMENT,
        integrations: [
            new Sentry.Replay(),
            new CaptureConsoleIntegration({
                levels: ['error'],
            }),
        ],
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event, hint) {
            const exception = hint?.originalException;
            if (exception instanceof Error && exception.message === 'Cannot call hover while not dragging.') {
                return null;
            }
            return event;
        },
    });
}

installCustomerAuthRefresh();

ReactDOM.render(
    <Sentry.ErrorBoundary fallback={({ resetError }) => <AppErrorFallback onNavigate={resetError} />}>
        <App />
    </Sentry.ErrorBoundary>,
    document.getElementById('customer-portal')
);

serviceWorker.unregister();
